export enum ExternalLinkEnums {
    VIEW = 'view',
}

